import type { ReactNode } from 'react';
import styles from './BlankState.module.scss';

type Props = {
  title: string;
  hint?: ReactNode;
  action?: ReactNode;
};

export const BlankState = ({ title, hint, action }: Props) => {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      {hint ? <div className={styles.hint}>{hint}</div> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
};
